import {SerializeTo} from '../utils/serializer/serialize';

export const ApiSerializer = {
  toCamelCase<SerializedObject extends object | void>(data?: any): SerializedObject {
    return SerializeTo.CamelCase(data) as SerializedObject;
  },
  toSnakeCase<RequestBody extends object | undefined, SnakeCaseObject extends object | void = object>(
    data?: RequestBody
  ): SnakeCaseObject {
    return SerializeTo.SnakeCase(data) as SnakeCaseObject;
  },
};
